export const WEBSITE = {
    DOMAIN: 'www.identity-services-llc.com'
}